import { ComponentsMappers } from './types'
import * as WFacebookLike from './components/WFacebookLike/WFacebookLike'
import * as FacebookShare from './components/FacebookShare/FacebookShare'
import * as TextAreaInput from './components/TextAreaInput/TextAreaInput'
import * as PinterestPinIt from './components/PinterestPinIt/PinterestPinIt'
import * as PayPalButton from './components/PayPalButton/PayPalButton'
import * as YouTubeSubscribeButton from './components/YouTubeSubscribeButton/YouTubeSubscribeButton'
import * as VerticalAnchorsMenu from './components/VerticalAnchorsMenu/VerticalAnchorsMenu'
import * as WTwitterTweet from './components/WTwitter/WTwitterTweet/WTwitterTweet'
import * as WTwitterFollow from './components/WTwitter/WTwitterFollow/WTwitterFollow'
import * as SpotifyPlayer from './components/SpotifyPlayer/SpotifyPlayer'
import * as TextInput from './components/TextInput/TextInput'
import * as VideoPlayer from './components/VideoPlayer/VideoPlayer'
import * as Video from './components/VideoLegacy/VideoLegacy'
import * as VKShareButton from './components/VKShareButton/VKShareButton'
import * as Masonry from './components/Masonry/Masonry'
import * as StripSlideshow from './components/StripSlideshow/StripSlideshow'
import * as MusicPlayer from './components/MusicPlayer/MusicPlayer'
import * as StripShowcase from './components/StripShowcase/StripShowcase'
import * as DatePickerCalendar from './components/DatePickerCalendar/DatePickerCalendar'
import * as TPA3DGallery from './components/Tpa3DGallery/Tpa3DGallery'
import * as TPA3DCarousel from './components/Carousel/Carousel'
import * as Freestyle from './components/Freestyle/Freestyle'
import * as Honeycomb from './components/Honeycomb/Honeycomb'
import * as Thumbnails from './components/Thumbnails/Thumbnails'
import * as Accordion from './components/Accordion/Accordion'
import * as Impress from './components/Impress/Impress'
import * as Collage from './components/Collage/Collage'
import * as DisqusComments from './components/DisqusComments/DisqusComments'
import * as SpotifyFollow from './components/SpotifyFollow/SpotifyFollow'
import * as PinItPinWidget from './components/PinItPinWidget/PinItPinWidget'
import * as SoundCloudWidget from './components/SoundCloudWidget/SoundCloudWidget'
import * as FlickrBadgeWidget from './components/FlickrBadgeWidget/FlickrBadgeWidget'
import * as Grid from './components/Grid/Grid'
import * as SlideShowContainer from './components/SlideShowContainer/SlideShowContainer'
import * as Pagination from './components/Pagination/Pagination'
import * as SlideShowSlide from './components/SlideShowSlide/SlideShowSlide'
import * as RatingsInput from './components/RatingsInput/RatingsInput'
import * as SelectionTagsList from './components/SelectionTagsList/SelectionTagsList'
import * as ToggleSwitch from './components/ToggleSwitch/ToggleSwitch'
import * as LineShareButton from './components/LineShareButton/LineShareButton'
import * as Captcha from './components/Captcha/Captcha'
import * as CustomElementComponent from './components/CustomElementComponent/CustomElementComponent'
import * as RichTextBox from './components/RichTextBox/RichTextBox'
import * as RatingsDisplay from './components/RatingsDisplay/RatingsDisplay'
import * as SlideShowGallery from './components/SlideShowGallery/SlideShowGallery'
import * as TimePicker from './components/TimePicker/TimePicker'
import * as SingleAudioPlayer from './components/SingleAudioPlayer/SingleAudioPlayer'
import * as DatePicker from './components/DatePicker/DatePicker'
import * as AudioPlayer from './components/AudioPlayer/AudioPlayer'

export const componentsMappers: ComponentsMappers = {
	TextInput,
	WFacebookLike,
	FacebookShare,
	TextAreaInput,
	PinterestPinIt,
	PayPalButton,
	YouTubeSubscribeButton,
	VideoPlayer,
	Video,
	VerticalAnchorsMenu,
	WTwitterTweet,
	WTwitterFollow,
	SpotifyPlayer,
	VKShareButton,
	MusicPlayer,
	Masonry,
	StripSlideshow,
	DatePicker,
	StripShowcase,
	DatePickerCalendar,
	TPA3DGallery,
	TPA3DCarousel,
	Freestyle,
	Honeycomb,
	Thumbnails,
	Accordion,
	Impress,
	Collage,
	DisqusComments,
	SpotifyFollow,
	PinItPinWidget,
	SoundCloudWidget,
	SlideShowContainer,
	SlideShowSlide,
	Pagination,
	FlickrBadgeWidget,
	Grid,
	RatingsInput,
	SelectionTagsList,
	ToggleSwitch,
	LineShareButton,
	Captcha,
	CustomElementComponent,
	RichTextBox,
	RatingsDisplay,
	SlideShowGallery,
	TimePicker,
	AudioPlayer,
	SingleAudioPlayer,
}
